import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import { getHoldingSchemaAdditionalFields, holdingSchema } from "./holding";
import { getSubletSchemaAdditionalFields, subletSchema } from "./sublet";

export const holdingWithSubletSchema = holdingSchema.extend({
  sublets: z.array(subletSchema),
});

export type HoldingWithSublet = z.infer<typeof holdingWithSubletSchema>;

export function getHoldingWithSubletSchemaAdditionalFields(additionalFields: {
  holding: typeof additionalDataSchema;
  sublet: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
}): typeof holdingWithSubletSchema {
  return getHoldingSchemaAdditionalFields(additionalFields).extend({
    sublets: z.array(getSubletSchemaAdditionalFields(additionalFields)),
  });
}
